// extracted by mini-css-extract-plugin
export default {"statistics":"HttpMonitorStatistics_statistics__-oTGG"};